import React from 'react';

const FourthPage = () => {
  return (
    <div className="page-section">
      <div className="container mt-4">
        <div className="row align-center">
          <div className="col-md-12 text-center title-text">
            NAD+ giảm trong cơ thể theo thời gian
          </div>
        </div>
        <div className="row align-center mt-2">
          <div className="col-md-12 text-center body-text" style={{ maxWidth: '900px' }}>
          Mức NAD+ giảm theo tuổi tác điều này có thể <br /> gây tổn thương tế bào tăng nguy cơ mắc bệnh và làm tăng tốc quá trình lão hóa.          </div>
        </div>
        <div className="row align-center mt-2">
          <div className="col-md-12 text-center">
            <img src="/images/nad2-2.png" alt="Product" className="img-fluid" style={{ width: '100%', maxWidth: '800px' }} loading="lazy" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FourthPage; 